var Product = Backbone.Model.extend( {
    //            url: '_requests/ecommerce/Product/intergard.json',
    //            url: '_requests/ecommerce/Product/sableseek.json',
    // url: '_requests/ecommerce/Product/starbrush.json', // option group only
    //            url: '_requests/ecommerce/Product/permaflo-pink.json', // single sku

    //            url: '_requests/ecommerce/Product/sableseek-alt.json',
    //            url: '_requests/ecommerce/Product/opalescence-pf.json', // full configuration
    //            url: '_requests/ecommerce/Product/endoeze.json', // full configuration

    defaults: {
        "name": "",
        "id": null,
        //                "configurations": [],
        //                "optionGroups": [],
        //                "optionDetails": [],
        //                "skus": []
    }
} );

export default Product;
